import styled from 'styled-components';
import React, { FC, ReactNode } from 'react';
import { Typography } from '../Typography';
import { TrevorIcon } from '../TrevorIcon';

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-m);
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const ListItem = styled.li`
  background: var(--color-interface-neutral-light);
  border: 1px solid var(--color-interface-layout-normal);
  border-radius: var(--radius-8);
  padding: var(--spacing-l);
  transition: var(--transition-fast);

  :hover {
    cursor: pointer;
    box-shadow: var(--elevation-soft);
    border: 1px solid var(--color-interface-secondary-lighter);
  }
`;

const StyledListItemWithLabelsAndAction = styled(ListItem)`
  display: flex;
  text-align: start;

  > div:first-of-type {
    width: 75%;

    > div {
      display: inline-flex;
      gap: calc((var(--spacing-xxs) * 2));
      justify-content: start;
      margin-top: 12.5px;
    }
  }

  > div:last-of-type {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: end;
    color: var(--color-interface-secondary-normal);

    > p {
      display: inline-flex;
      margin: 0;

      > svg {
        margin-left: var(--spacing-s);
      }
    }
  }
`;

type ListItemWithLabelsAndActionProps = {
  title: ReactNode;
  actionLabel: string;
  labels?: ReactNode;
  onClick?: () => void;
};

export const ListItemWithLabelsAndAction: FC<
  ListItemWithLabelsAndActionProps
> = ({ title, actionLabel, labels, onClick }) => {
  return (
    <StyledListItemWithLabelsAndAction onClick={onClick}>
      <div>
        <Typography tag="p" variant="subtitle">
          {title}
        </Typography>
        <div>{labels}</div>
      </div>
      <div>
        <Typography tag="p" variant="text">
          {actionLabel} <TrevorIcon name="chevron-right" />
        </Typography>
      </div>
    </StyledListItemWithLabelsAndAction>
  );
};
